import { render, staticRenderFns } from "./LongDistance.vue?vue&type=template&id=63f9c720&scoped=true&"
import script from "./LongDistance.vue?vue&type=script&lang=js&"
export * from "./LongDistance.vue?vue&type=script&lang=js&"
import style0 from "./LongDistance.vue?vue&type=style&index=0&id=63f9c720&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9c720",
  null
  
)

export default component.exports